/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const unlinkTelegramOidcResponseSchema = z.object({
  success: z.boolean(),
  unlinked: z.boolean(),
});

export type IUnlinkTelegramOidcResponse = z.infer<typeof unlinkTelegramOidcResponseSchema>;
